module.exports = __webpack_public_path__ + "static/media/jennifergoodall.b0deea40.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jennifergoodall.webp
// module id = 361
// module chunks = 0